import { Injectable } from '@angular/core';
import { BehaviorSubjectItem } from './behavior-subject-item';
import * as mapboxgl from "mapbox-gl";
import {AgentPromo} from "../pages/workspace/features/create-workspace/services/workspace-api.service";

@Injectable({
  providedIn: 'root',
})
export class AppStore {
  public isPayPending: BehaviorSubjectItem<boolean> = new BehaviorSubjectItem<boolean>(false);
  public initialPlotUUID: BehaviorSubjectItem<string> = new BehaviorSubjectItem('');
  public initialListingUUID: BehaviorSubjectItem<string> = new BehaviorSubjectItem('');
  public initialReferrerUUID: BehaviorSubjectItem<string> = new BehaviorSubjectItem('');

  public openedPromotes: AgentPromo[] = [];
  public tempMap: mapboxgl.Map | null = null;

  constructor() {
  }
}
